var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_241899327781510248139557786147878805522",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_91657333290362732782556843959269345721",
    d: "M12.094 18.846l-6.81-7.006c-.378-.388-.378-1.006 0-1.394l6.81-7.006c.616-.633.616-1.64 0-2.273-.593-.61-1.568-.624-2.179-.03l-.03.03-9.021 9.279c-.378.388-.378 1.006 0 1.394l9.02 9.279c.594.61 1.57.624 2.18.03l.03-.03c.616-.633.616-1.64 0-2.273z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-106 -378) translate(98 312) matrix(0 -1 -1 0 41 99) rotate(-90 14.333 9.333) translate(0 .857)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_334535970702228727836645966603639878831",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_91657333290362732782556843959269345721"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#hinava_random_uuid_91657333290362732782556843959269345721"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#hinava_random_uuid_241899327781510248139557786147878805522)",
    mask: "url(#hinava_random_uuid_334535970702228727836645966603639878831)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.5,
    height: 105.429,
    rx: 8,
    transform: "translate(-108.333 -44.571)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.392b6f76bf4669f8ef211cd03910712f.svg";
export { ForwardRef as ReactComponent };